import { Actions, ActionTypes } from './actions';
import { Account, PayExConnection } from '../../../types/management-auth';

export enum PayExModalState {
    Closed = 'Closed',
    ApplicationForm = 'ApplicationForm',
    InitiateApplicationLoading = 'InitiateApplicationLoading',
    ApplicationReceived = 'ApplicationReceived',
    ShowFormLink = 'ShowFormLink',
}

export interface State {
    payexConnectionResponse: PayExConnection | undefined;
    payexModalState: PayExModalState;
    account: Account | undefined;
    formUrl: string | undefined;
}

export const initialState: State = {
    payexConnectionResponse: undefined,
    payexModalState: PayExModalState.Closed,
    account: undefined,
    formUrl: undefined,
};

export function reducer(state: State = initialState, action: Actions) {
    switch (action.type) {
        case ActionTypes.OpenPayExModal:
            return {
                ...state,
                payexModalState: PayExModalState.ApplicationForm,
                account: action.payload.account,
            };

        case ActionTypes.InitiatePayExConnection:
            return {
                ...state,
                formUrl: action.payload.formUrl,
                payexModalState: PayExModalState.InitiateApplicationLoading,
            };

        case ActionTypes.FetchInitiatePayExConnectionResponse:
            const payexModalState = state.formUrl ? PayExModalState.ShowFormLink : PayExModalState.ApplicationReceived;
            return {
                ...state,
                payexConnectionResponse: action.payload.response,
                payexModalState,
            };

        case ActionTypes.OpenPayexForm:
            return {
                ...state,
                payexModalState: PayExModalState.ApplicationReceived,
            };

        case ActionTypes.ClosePayExModal:
            return {
                ...initialState,
            };

        default:
            return state;
    }
}
